module.exports = __webpack_public_path__ + "img/thunderbolt.6c04b6a1.png";